import { render, staticRenderFns } from "./IngenierieConseilPatrimoniaux.vue?vue&type=template&id=a20c8c7e&"
import script from "./IngenierieConseilPatrimoniaux.vue?vue&type=script&lang=js&"
export * from "./IngenierieConseilPatrimoniaux.vue?vue&type=script&lang=js&"
import style0 from "./IngenierieConseilPatrimoniaux.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports